export default __webpack_public_path__ + "static/media/logout.149b5993.svg";